module.exports = __webpack_public_path__ + "static/media/admins-smart.f145bbf6.svg";